module.exports = __webpack_public_path__ + "img/31-3BX.2e1cad9.jpg";